// Helper to core helpers

import { CoreHelpers, AccountHelpers } from './config';

interface IValidation {
  isValid: boolean;
  type: string | undefined;
}

export function validate({ isValid, type: identityType }: IValidation): boolean {
  if (isValid) return isValid;
  return !identityType;
}

// Core helpers

export const formatMask = (str: string, mask: string, reverse?: boolean | undefined): any => {
  return AccountHelpers.formatMask(str, mask, reverse);
};

export const isValidMemberNumberOrCPF = (value: string) => {
  return AccountHelpers.isValidMemberNumberOrCPF(value);
};

export const isValidEmail = (value: string) => {
  return { isValid: CoreHelpers.validations.isValidEmail(value), type: 'EMAIL' };
};

export const isValidName = (value: string) => {
  return AccountHelpers.isValidName(value);
};

export const isValidPhoneNumber = (phoneNumber: string) => {
  return AccountHelpers.isValidPhoneNumber(phoneNumber);
};
